
import { Carousel } from 'js/common/modules/carousel.js';

export function setupSalonServicesCarousel() {
  const outerList = document.getElementById('salon-services-wrapper');
  if (outerList == null) {
    return;
  }

  let outerCarouselSettings = {
    arrows: false,
    draggable: false,
    swipe: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: false,
          draggable: false,
          swipe: false
        }
      }
    ]
  }

  outerList.Carousel = new Carousel(outerList, outerList, outerCarouselSettings);
  outerList.Carousel.setupTabClicks('.services-tab-button','.services-tab-item');

  const innerList = document.querySelectorAll('.salon-section-list');
  let innerCarouselSettings = {
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: true,
    arrows: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  }

  for (const innerEl of innerList) {
    innerEl.Carousel = new Carousel(innerEl, outerList, innerCarouselSettings);
  }
}
